import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const Matcher = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M15 10.214v5h-5v2h7v-7z" />
    <path d="M17 7.214v-6H1v16h6v6h16v-16h-6zm-10 8H3v-12h12v4H7v8zm14 6H9v-12h12v12z" />
  </SvgIcon>
);

export default Matcher;
